import PropTypes from 'prop-types';
import { useFormContext } from './context';
import './styles.less';
const {
  ControlGroup
} = svs.ui.reactForm;
export const getEmptyFieldValue = type => {
  switch (type || 'text') {
    default:
      return '';
  }
};
const FormFieldTextarea = ({
  id,
  isDisabled
}) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const {
    formData,
    updateField
  } = useFormContext();
  const value = formData[id] ?? '';
  const handleChange = event => {
    updateField(id, event.target.value);
  };
  return <ControlGroup errorMessage="" hasError={false} v2>
      <div className="textarea-wrapper">
        <textarea autoCapitalize="off" autoComplete="off" autoCorrect="off" className="form-textarea" disabled={isDisabled} id={id} maxLength={255} onBlur={() => setIsFocused(false)} onChange={handleChange} onFocus={() => setIsFocused(true)} spellCheck={false} value={value} />
        {!isFocused && !value && <label className="form-label" htmlFor={id}>
            Kommentar
          </label>}
      </div>
    </ControlGroup>;
};
FormFieldTextarea.propTypes = {
  id: PropTypes.string.isRequired,
  isDisabled: PropTypes.bool
};
export default FormFieldTextarea;